export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';
export const SET_CRITERE = 'SET_CRITERE';
export const SET_CRITERE_RECHERCHE_RECONDUCTIBLE = 'SET_CRITERE_RECHERCHE_RECONDUCTIBLE';
export const SET_CONTRAT = 'SET_CONTRAT';
export const REMOVE_CONTRAT = 'REMOVE_CONTRAT';
export const SET_FILTRE_ALREADY_APPLY = 'SET_FILTRE_ALREADY_APPLY';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
